import {
    Box,
    Typography,
    List,
    ListItem,
    ListItemAvatar,
    IconButton,
    Avatar,
    Chip,
    Stack,
} from '@mui/material';
import { FC, ReactNode, MouseEvent } from 'react';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import PaidIcon from '@mui/icons-material/MonetizationOn';
import {
    currencyFormatter,
    PaymentDirection,
    PaymentMethod,
    PaymentStatus,
    DescriptionCode,
    formatDateLong,
} from '@lendica/utils';
import { mapCodeToLabel } from '../utils';
import ProductBadge from './ProductBadge';
import PaymentBadge from './PaymentBadge';
import StatusBadge from './StatusBadge';

export interface ActivityListItemProps {
    dealId: string;
    amount: number;
    product: string;
    date: string;
    paymentDirection: PaymentDirection;
    paymentMethod: PaymentMethod;
    paymentStatus: PaymentStatus;
    descriptionCode: DescriptionCode;
    hasNavigation?: boolean;
    onNavigationClick?(e: MouseEvent<HTMLElement>): void;
}

export const ActivityListItem: FC<ActivityListItemProps> = ({
    dealId,
    amount,
    product,
    date,
    paymentDirection,
    paymentMethod,
    paymentStatus,
    descriptionCode,
    hasNavigation = false,
    onNavigationClick,
}) => {
    const signedAmount = (paymentDirection: PaymentDirection, amount: number) => {
        return paymentDirection === 'To Customer' ? +Math.abs(amount) : -Math.abs(amount);
    };

    return (
        <ListItem sx={{ width: '100%', boxSizing: 'border-box' }} disableGutters divider>
            <Box flex="1" display="flex" flexDirection="column" gap={0.25}>
                <Box sx={{ display: 'flex', flexDirection: 'row' }}>
                    <Typography variant="body2" color="text.primary">
                        {formatDateLong(date)}
                    </Typography>
                </Box>

                <Stack direction="row" spacing={1}>
                    <Chip size="small" key={dealId} label={dealId} />
                    <PaymentBadge label={mapCodeToLabel(descriptionCode, paymentDirection) ?? ''} />
                </Stack>
            </Box>

            <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-end"
                justifyContent="flex-start"
                height="100%"
                gap={0.25}
            >
                <Typography variant="body2" color="text.primary">
                    {currencyFormatter(signedAmount(paymentDirection, amount))}
                </Typography>
                <Stack direction="row" spacing={1}>
                    {!!product && <ProductBadge transactionType={product} />}
                    <StatusBadge status={paymentStatus} />
                </Stack>
            </Box>

            {hasNavigation && (
                <IconButton size="large" onClick={onNavigationClick}>
                    <ArrowForwardIosIcon />
                </IconButton>
            )}
        </ListItem>
    );
};
